import { Controller } from "@hotwired/stimulus"
import { activateFocusTrap, deactivateFocusTrap } from "./utils/focus_trap"
import { applyEnter, animateOut } from "./utils/motion"

// Side sheet (drawer). Triggered by `data-sheet-trigger="<id>"` from anywhere.
//
// A11y (WAI-ARIA APG Dialog):
//   - Focus trap + restore (utils/focus_trap)
//   - Esc fecha (document listener — funciona mesmo com foco fora do painel)
//   - Inert nos siblings ao abrir
//
// Motion: painel desliza a partir da sua borda (animate-sheet-in/out-<side>),
// backdrop faz fade. O `side` vem de `data-sheet-side-value` (default right).
// Ao fechar, espera a animação de saída antes de esconder. Respeita
// `prefers-reduced-motion` via utils/motion.
export default class extends Controller {
  static targets = ["root", "panel", "backdrop"]
  static values  = { id: String, side: { type: String, default: "right" } }

  connect() {
    this.boundOpen = (e) => {
      const trigger = e.target.closest(`[data-sheet-trigger="${this.idValue}"]`)
      if (trigger) { e.preventDefault(); this.open() }
    }
    this.boundKeydown = (e) => {
      if (e.key === "Escape" && !this.rootTarget.classList.contains("hidden")) {
        this.close()
      }
    }
    document.addEventListener("click", this.boundOpen)
    document.addEventListener("keydown", this.boundKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.boundOpen)
    document.removeEventListener("keydown", this.boundKeydown)
    if (this.trap) deactivateFocusTrap(this.trap)
  }

  open() {
    this.rootTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    if (this.hasPanelTarget) applyEnter(this.panelTarget, `animate-sheet-in-${this.sideValue}`)
    if (this.hasBackdropTarget) applyEnter(this.backdropTarget, "animate-backdrop-in")
    this.trap = activateFocusTrap(this.rootTarget)
  }

  async close() {
    await Promise.all([
      this.hasPanelTarget ? animateOut(this.panelTarget, `animate-sheet-out-${this.sideValue}`) : null,
      this.hasBackdropTarget ? animateOut(this.backdropTarget, "animate-backdrop-out") : null
    ])
    this.rootTarget.classList.add("hidden")
    document.body.style.overflow = ""
    deactivateFocusTrap(this.trap)
    this.trap = null
  }
}
